import { Image, Flex, Title, Text } from '@mantine/core';
import type { ReactElement, ReactNode } from 'react';
import classes from './loginForm.module.scss';

type LoginFormProps = {
  children: ReactElement | ReactNode | string;
  title?: string;
  description?: string;
};

export const LoginForm = ({ children, title, description }: LoginFormProps) => {
  return (
    <Flex p={{ base: 16, sm: 24, md: 48 }} className={classes.container}>
      <Image src='/logo.webp' w={207} h={46} mb={48} />

      {title && (
        <Title order={3} mb={8}>
          {title}
        </Title>
      )}

      {description && <Text c='tertiary.7'>{description}</Text>}

      {children}
    </Flex>
  );
};
